export default "__VITE_ASSET__CIkzkp6p__"